export const translateDeliveryNoteStatus = (status) => {
    if (status === 'sent') {
        return 'Gesendet';
    }
    else if (status === 'charged') {
        return 'Verrechnet';
    }
}
